import React from 'react';

import {
  PROJECT_DETAILS_UPDATED,
  PROJECT_UPDATED,
  ProjectDetailsFieldType,
  ProjectDetailsFieldValue,
  useProjectDetailsService,
} from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import { useProjectId } from 'features/nekst-widgets';
import LoadingAnimation from '../../../shared/LoadingAnimation';
import InnerBlock from '../../../shared/web/layout/InnerBlock';
import InformationFieldsBlock from './InformationFieldsBlock';
import DatesFieldsBlock from './DatesFieldsBlock';
import FinancialFieldsBlock from './FinancialFieldsBlock';
import { ProjectDetailFieldRow } from './types';

function mapFields(fields: ProjectDetailsFieldValue[]): ProjectDetailFieldRow[] {
  return fields.map((f) => ({ ...f, id: f.setting.id }));
}

export default function ProjectDetailFieldsBlock() {
  const projectId = useProjectId();
  const projectDetailsService = useProjectDetailsService();

  const { data } = useDataLoaderNew(
    () => projectDetailsService.getProjectDetails(projectId),
    {
      dependencies: [projectId],
      events: [PROJECT_UPDATED, PROJECT_DETAILS_UPDATED],
    },
  );

  if (!data) {
    return <LoadingAnimation />;
  }

  const informationFields = mapFields(
    data.filter((f) =>
      f.setting.fieldType === ProjectDetailsFieldType.SHORT_TEXT
      || f.setting.fieldType === ProjectDetailsFieldType.LONG_TEXT,
    ),
  );

  const dateFields = mapFields(
    data.filter((f) => f.setting.fieldType === ProjectDetailsFieldType.DATE),
  );

  const financialFields = mapFields(
    data.filter((f) => f.setting.fieldType === ProjectDetailsFieldType.PRICE),
  );

  return (
    <InnerBlock
      title="Important Dates and Details"
      testId="edit-details"
    >
      <InformationFieldsBlock fields={informationFields} />
      <DatesFieldsBlock fields={dateFields} />
      <FinancialFieldsBlock fields={financialFields} />
    </InnerBlock>
  );
}
